module.exports = __webpack_public_path__ + "assets/42.jpg?7f547c22dc60b35d73439eb62fbe4d07";